import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function CoinsIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1203_1337)">
        <path
          d="M25.4567 50.9135C39.5161 50.9135 50.9135 39.5161 50.9135 25.4567C50.9135 11.3974 39.5161 0 25.4567 0C11.3974 0 0 11.3974 0 25.4567C0 39.5161 11.3974 50.9135 25.4567 50.9135Z"
          fill="#00416B"
        />
        <path
          d="M25.4566 45.4445C36.4957 45.4445 45.4445 36.4957 45.4445 25.4566C45.4445 14.4176 36.4957 5.46875 25.4566 5.46875C14.4176 5.46875 5.46875 14.4176 5.46875 25.4566C5.46875 36.4957 14.4176 45.4445 25.4566 45.4445Z"
          fill="#FBFCFE"
        />
        <path
          d="M54.5437 79.9999C68.603 79.9999 80.0004 68.6025 80.0004 54.5432C80.0004 40.4838 68.603 29.0864 54.5437 29.0864C40.4843 29.0864 29.0869 40.4838 29.0869 54.5432C29.0869 68.6025 40.4843 79.9999 54.5437 79.9999Z"
          fill="#00416B"
        />
        <path
          d="M54.5436 74.5312C65.5826 74.5312 74.5315 65.5823 74.5315 54.5433C74.5315 43.5043 65.5826 34.5554 54.5436 34.5554C43.5046 34.5554 34.5557 43.5043 34.5557 54.5433C34.5557 65.5823 43.5046 74.5312 54.5436 74.5312Z"
          fill="#FBFCFE"
        />
        <path
          d="M61.1256 59.1409L65.6024 61.3672C63.4729 65.0695 59.6495 67.441 54.8341 67.441C48.8328 67.441 44.3561 63.7386 42.759 58.4634H38.4033L40.6054 54.882H42.2025C42.1783 54.6158 42.1783 54.398 42.1783 54.1802V53.5753H38.4033L40.6054 49.9697H42.759C44.2835 44.646 48.8086 40.8711 54.8341 40.8711C59.6495 40.8711 63.4729 43.2667 65.6024 46.9449L61.1256 49.2196C59.8673 47.1385 57.6895 45.8318 54.8341 45.8318C51.6399 45.8318 49.2926 47.4773 48.0827 49.9697H60.4239L58.2218 53.5753H47.2357V54.1802C47.2357 54.398 47.2357 54.6642 47.2599 54.882H57.9073L55.9472 58.4634H48.1553C49.341 60.9316 51.6641 62.4803 54.8341 62.4803C57.7137 62.4803 59.8673 61.1736 61.1256 59.1167V59.1409Z"
          fill="#5FD6C3"
        />
        <path
          d="M27.3442 8.73562V12.4138C30.49 12.9462 33.3212 14.9062 33.9262 17.9068L29.6672 19.5039C29.4495 18.4634 28.5057 17.7374 27.3442 17.3261V22.8191C31.8693 24.271 35.1603 25.9891 35.1603 30.4174C35.1603 34.2892 32.6678 37.6527 27.3442 38.1125V41.4035H23.3756V37.9431C19.5039 37.2656 16.3581 34.8941 15.7773 31.8935L20.1815 30.1996C20.496 31.5789 21.7302 32.5953 23.3515 33.055V26.7635C18.4634 25.0938 16.4549 22.9643 16.4549 19.5281C16.4549 16.6001 18.3666 13.1397 23.3515 12.3654V8.71143H27.32L27.3442 8.73562ZM23.3515 21.4156V17.3019C22.2625 17.6164 21.5366 18.3182 21.5366 19.3587C21.5366 20.1573 21.9237 20.738 23.3515 21.4156ZM27.3442 28.0702V33.1276C29.0865 32.7647 30.0302 31.7967 30.0302 30.5868C30.0302 29.4737 29.3527 28.8445 27.3442 28.046V28.0702Z"
          fill="#5FD6C3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1203_1337">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
